import { useState } from 'react'
import { MoonStar } from 'lucide-react'

interface WorkImageProps {
  src: string
  alt: string
}

// تصویر نمونه‌کار با جایگزین برند‌شده — اگر اینترنت/CDN در دسترس نباشد، کاشی طراحی‌شده نمایش داده می‌شود
const WorkImage = ({ src, alt }: WorkImageProps) => {
  const [failed, setFailed] = useState(false)

  if (failed) {
    return (
      <div className="w-full aspect-[3/4] flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-secondary-100 to-primary-100 dark:from-secondary-900/40 dark:to-primary-900/40 text-secondary-500 dark:text-secondary-300">
        <MoonStar className="h-8 w-8" />
        <span className="text-sm tracking-widest opacity-70">{alt}</span>
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className="w-full aspect-[3/4] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
    />
  )
}

export default WorkImage
